import { createSlice } from '@reduxjs/toolkit';
import { IBrokerRegister } from '../../../broker/interfaces/IBrokerRegister';
import { BrokerRegisterReducer } from '../../reducers/BrokerRegisterReducer';

const initialState: IBrokerRegister = {};

export const brokerRegisterSlice = createSlice({
	name: 'brokerRegister',
	initialState,
	reducers: BrokerRegisterReducer
});

export const {
	setBrokerRegister,
	setReceitaResponse,
	setSusepResponse,
} = brokerRegisterSlice.actions;

export default brokerRegisterSlice.reducer;
